import { render } from "./farmTable.vue?vue&type=template&id=48182926&scoped=true"
import script from "./farmTable.vue?vue&type=script&lang=js"
export * from "./farmTable.vue?vue&type=script&lang=js"

import "./farmTable.vue?vue&type=style&index=0&id=48182926&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48182926"]])

export default __exports__